// extracted by mini-css-extract-plugin
export default {"botaoSalvar":"BotaoSalvar_botaoSalvar__JuY02"};